import { render, staticRenderFns } from "./JobAlertPagination.vue?vue&type=template&id=1e52f542&scoped=true&"
import script from "./JobAlertPagination.vue?vue&type=script&lang=ts&"
export * from "./JobAlertPagination.vue?vue&type=script&lang=ts&"
import style0 from "./JobAlertPagination.vue?vue&type=style&index=0&id=1e52f542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e52f542",
  null
  
)

export default component.exports